import { storyblokEditable } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import { RichTextField } from "@/components/typography/RichTextField";
import { cn } from "@/lib/utils";

type HeadlineBlockStoryblok = {
  subline?: string;
  title?: string;
  text?: string;
  alignment?: "left" | "center";
  _uid: string;
  component: "headline_block";
  [k: string]: any;
};

type HeadlineBlockProps = {
  blok: HeadlineBlockStoryblok;
};

const HeadlineBlock = ({ blok }: HeadlineBlockProps) => {
  const centered = blok.alignment === "center";

  return (
    <section className="py-12 md:py-16" {...storyblokEditable(blok)}>
      <GridContainer>
        <div
          className={cn(
            "col-span-12 md:col-span-10 md:col-start-1 lg:col-span-8 lg:col-start-3",
            centered && "text-center",
          )}
        >
          {(blok.subline || blok.title) && (
            <div className="flex flex-col gap-1">
              {blok.subline && <p className="text-copy-bold">{blok.subline}</p>}
              {blok.title && <h2 className="text-headline-xl">{blok.title}</h2>}
            </div>
          )}

          {blok.text && (
            <RichTextField value={blok.text} className="text-copy mt-6" />
          )}
        </div>
      </GridContainer>
    </section>
  );
};

export default HeadlineBlock;
